import React, { Component } from 'react';
import { Container } from "reactstrap";

//Import Images
import sandClock from "../../images/icon/sand-clock.svg";
import security from "../../images/icon/security.svg";
import payment from "../../images/icon/payment.svg";
import speedometer from "../../images/icon/speedometer.svg";
import code from "../../images/icon/code.svg";
import cardiogram from "../../images/icon/cardiogram.svg";
import smart from "../../images/icon/ai.svg";
import server from "../../images/icon/server.svg";
import customerService from "../../images/icon/customer-service.svg";

//Import Components
import SectionTitle from "../../components/Shared/section-title";
import Feature from "../../components/Shared/Feature";

class Features extends Component {
    state = {
        features : [
            { id : 1, imgUrl : speedometer, title : "Never Loose Signals, No Stale trading", description : ["Never miss a single trade action, opening, amending and closing orders automatically", "No outdated trading actions because of real time execution" ] },
            { id : 2, imgUrl : code, title : "Any telegram channel, DIY", description : [ "Any telegram channel, any message format, any asset class & any number of trading accounts", "Complete access to configurations" ] },
            { id : 3, imgUrl : cardiogram, title : "Lifetime Licence", description : [ "Unlimited number of telegram channels & trade action volume", "Lifetime licence & support" ] },
            { id : 4, imgUrl : sandClock, title : "Trailing Stop", description : [ "Set trailing stop and break even point that you have the full control of your account", "Default stop loss when not present in trade action"] },
            { id : 5, imgUrl : payment, title : "Multiple Take Profits", description : [ "When trade action contains multiple TPs, multiple positions are opened for each TP value and moves SL accoridngly IE. And after TP1 hit, TP2 and TP3 order moves SL to entry, and after TP2 hit, TP3 order moves SL to TP1"] },
            { id : 6, imgUrl : smart, title : "Smart Lot Sizes", description : [ "Set lot size based on the risk exposure of the account", "Adjust lot size dynamically", "Lot per symbol"] },
            { id : 7, imgUrl : security, title : "Inbuilt Salvage Telegram Channel", description : [ "Control any trade actions", "Override any trade action behaviour"] },
            { id : 8, imgUrl : server, title : "Standalone Deployment", description : [ "TelegramTradeCopier is standalone, doesn’t rely on any external servers such secure and you have the control. "] },
            { id : 9, imgUrl : customerService, title : "24/7 Helpdesk and Upgrades", description : [ "Attending queries, installation, configuration and maintenance", "Periodic free updates available such you always run the latest version." ] },
        ]
    }

    render() {
        return (
            <React.Fragment>
            <Container>
                {/* section title */}
                <SectionTitle title="Fully Automated | Unlimited Channels | Lifetime Licence |  Configurable | 24/7 Help Desk" isH2={true}/>

                {/* feature box */}
                <Feature featureArray={this.state.features}/> 
            </Container>
            </React.Fragment>
        );
    }
}

export default Features;